import React from 'react';
import styles from './TeamReward.module.sass';
import { Avatars } from '../../../../../constants/const';
import { timeConvert } from '../../../../../utils/utils';

export function TeamReward({ seasonGoalStats }) {
  return (
    <div className={styles.teamReward}>
      <div className={styles.title}>
        {' '}
        <img
          className={styles.titleIcon}
          src={'/img/teams/AST_Team_Reward_icon.png'}
          alt="Season Goal"
        />
        TEAM REWARD
      </div>
      <div className={styles.counterContainer}>
        <div
          className={styles.counterContainerItem}
          style={{
            backgroundImage: 'url(/img/teams/reward_bg.svg)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
        >
          <div className={styles.counterTitle}>REWARD</div>
          <div className={styles.counter}>
            <h4 className={styles.counterSingleValue}>
              {seasonGoalStats.teamReward || 'Coach Surprise'}
            </h4>
          </div>
        </div>
        <div className={styles.counterContainerItem}>
          <div className={styles.counterTitle}>TOP PERFORMER</div>
          <div className={styles.counter}>
            <div className={styles.avatar}>
              <img
                src={
                  seasonGoalStats.topPerformerImage ||
                  Avatars[parseInt(seasonGoalStats.topPerformerPicture) - 1]
                }
                alt=""
              />
            </div>
            <div className={styles.valueContainer}>
              <div className={styles.value}>
                <span className={styles.valueTitle}>Videos:</span>{' '}
                <span className={styles.valueNumber}>
                  {seasonGoalStats.topPerformerVideos ?? 0}
                </span>
              </div>
              <div className={styles.value}>
                <span className={styles.valueTitle}>Time:</span>{' '}
                <span className={styles.valueNumber}>
                  {timeConvert(seasonGoalStats.topPerformerTime)}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
